export default "/images/ca5cb3b2d9725bd68164bea874343a5c.avif";